import { render, staticRenderFns } from "./TableBreadcrumbDropdown.vue?vue&type=template&id=226cd0ee&"
import script from "./TableBreadcrumbDropdown.vue?vue&type=script&lang=js&"
export * from "./TableBreadcrumbDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports